var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilibili(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0516 6.73335H20.5316L22.3449 5.02668C22.6649 4.70668 22.6649 4.17335 22.3449 3.85335C22.0249 3.53335 21.4916 3.53335 21.1716 3.85335L18.1849 6.73335H14.0249L10.9316 3.74668C10.6116 3.42668 10.0783 3.42668 9.75825 3.74668C9.43825 4.06668 9.43825 4.60002 9.75825 4.92002L11.5716 6.73335H8.05159C5.06492 6.73335 2.71825 9.08002 2.71825 12.0667V21.6667C2.71825 24.5467 5.06492 26.8933 7.94492 27C7.94492 27.8533 8.58492 28.4933 9.43825 28.4933C10.2916 28.4933 10.9316 27.8533 10.9316 27H21.0649C21.0649 27.8533 21.7049 28.4933 22.5583 28.4933C23.4116 28.4933 24.0516 27.8533 24.0516 27C26.9316 26.8933 29.2782 24.5467 29.2782 21.6667V12.0667C29.3849 9.08002 27.0382 6.73335 24.0516 6.73335ZM26.5049 21.88C26.5049 23.0533 25.5449 24.0133 24.3716 24.0133H7.73159C6.55825 24.0133 5.59825 23.0533 5.59825 21.88V11.8533C5.59825 10.68 6.55825 9.72002 7.73159 9.72002H24.3716C25.5449 9.72002 26.5049 10.68 26.5049 11.8533V21.88Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0265 13.5877L7.47437 14.6511L7.87565 16.7462L13.4278 15.6828L13.0265 13.5877Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 19.4668C18.1333 19.8668 17.7333 20.1335 17.4667 20.1335C17.0667 20.1335 16.675 19.7085 16.4479 19.4668C16.2208 19.2251 15.8667 18.6668 15.8667 18.6668C15.8667 18.6668 15.4896 19.271 15.3125 19.521C15.1354 19.771 14.8 20.1335 14.4 20.1335C14 20.1335 13.6 19.8668 13.2 19.3335L12 20.4001C12.8 21.3335 13.6 21.7335 14.4 21.7335C15.0667 21.7335 15.6 21.4668 15.8667 21.2001C16.2667 21.4668 16.8 21.7335 17.3333 21.7335C18.1333 21.7335 18.9333 21.3335 19.7333 20.4001L18.6667 19.4668Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9835 13.5955L18.5822 15.6907L24.1344 16.7541L24.5357 14.6589L18.9835 13.5955Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilibili);
export default __webpack_public_path__ + "static/media/bilibili.ff50093c2c871aec3c3ce8515452deb1.svg";
export { ForwardRef as ReactComponent };